const DEFAULT_FORM_ERROR =
  "Something went wrong. Please contact us at info@adexin.com. We apologize for the inconvenience."

export default DEFAULT_FORM_ERROR
